import styled from 'styled-components';

export const SkeletonStyled = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 16px 170px;
  gap: 40px;
  .ioSettingsSkeleton {
    &__flightsContainer, &__advancedContainer {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    
    &__selectors, &__flights, &__advanced {
      > div {
        width: 100%;
      }
      display: flex;
      flex-direction: row;
      gap: 16px;
    }
  }
`;
